export default __webpack_public_path__ + "contentweb/app/pages/Solutions/static/images/Solutions_Meta.29c33afd.png";